"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProvider = getProvider;

var _util = require("@cennznet/util");

var _rpcProvider = require("@plugnet/rpc-provider");

// Copyright 2019 Centrality Investments Limited
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
const REGEX = /^(wss?|https?):\/\//;

function getProvider(providerString) {
  const providerStringLowerCase = providerString.toLowerCase();
  const group = REGEX.exec(providerStringLowerCase);
  (0, _util.assert)(group, "Missing protocol: ".concat(providerString));
  const protocol = group[1];

  if (protocol === 'wss' || protocol === 'ws') {
    return new _rpcProvider.WsProvider(providerStringLowerCase);
  } else if (protocol === 'https' || protocol === 'http') {
    return new _rpcProvider.HttpProvider(providerStringLowerCase);
  } // All cases should be handled above, but if not, throw an error


  throw new Error("Invalid URL: ".concat(providerString));
}